import { createContext, useContext, type ParentProps } from "solid-js"

// GigaTool: chat deep links (`gigatool://open-session?directory=…&session=…`)
// are rendered as labelled chips, but the URL itself only carries the
// directory path — the label falls back to the folder basename, which for
// auto-created home chats is a meaningless `Chat-N`. The host app knows the
// real session titles (its sync stores hold them for every loaded directory),
// so it provides a resolver here; chip renderers (message-part
// HighlightedText, markdown linkChatSessions, the composer paste pill) ask it
// for a title and fall back to the basename when the session isn't loaded.
// The resolver must be read-only: it must never boot a directory instance
// (deep-link security gate — an unknown path in a pasted link stays inert).
export type ChatLinkTarget = { directory?: string; session?: string }

export type ChatLinkTitleResolver = (target: ChatLinkTarget) => string | undefined

const Context = createContext<ChatLinkTitleResolver>()

export function ChatLinkTitlesProvider(props: ParentProps<{ resolve: ChatLinkTitleResolver }>) {
  return <Context.Provider value={props.resolve}>{props.children}</Context.Provider>
}

export function useChatLinkTitles() {
  return useContext(Context)
}
